const MotorBikeIcon = ({ size = 24, color = 'currentColor', ...props }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 24 24'
        stroke={color}
        width={size}
        height={size}
        {...props}
    >
        <path
            d='M19.5 19C20.8807 19 22 17.8807 22 16.5C22 15.1193 20.8807 14 19.5 14C18.1193 14 17 15.1193 17 16.5C17 17.8807 18.1193 19 19.5 19Z'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M4.5 19C5.88071 19 7 17.8807 7 16.5C7 15.1193 5.88071 14 4.5 14C3.11929 14 2 15.1193 2 16.5C2 17.8807 3.11929 19 4.5 19Z'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M20.2351 7.87C21.5161 9.429 21.9621 10.912 21.9991 11.696C21.3033 11.3782 20.547 11.2148 19.7821 11.217C17.3371 11.217 15.1421 12.843 14.6181 15.009C14.4921 15.527 14.4301 15.786 14.2941 15.893C14.1581 16 13.9381 16 13.4991 16H10.6211C10.1781 16 9.95706 16 9.82106 15.892C9.68406 15.782 9.62406 15.525 9.50506 15.009C9.00906 12.871 6.99706 11.012 4.90206 11.169C4.69106 11.186 4.58506 11.194 4.51206 11.177C4.44106 11.161 4.36806 11.12 4.22206 11.037C3.80106 10.8 3.37106 10.574 2.95806 10.323C2.67495 10.1505 2.43918 9.91025 2.27196 9.62397C2.10473 9.3377 2.0113 9.01435 2.00006 8.683C1.98706 8.299 2.20706 7.919 2.65206 8.023L9.07206 9.534C9.55506 9.648 9.79606 9.704 10.0031 9.666C10.2101 9.628 10.4651 9.454 10.9731 9.106C12.2611 8.226 14.3031 7.393 16.3381 8.128C16.8951 8.329 17.1741 8.43 17.3321 8.435C17.4921 8.44 17.7241 8.372 18.1891 8.237C18.8553 8.04027 19.541 7.9172 20.2341 7.87C19.4321 6.892 18.3001 5.885 16.7341 5'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export default MotorBikeIcon;
